<template>
  <div class="referenced-pages">
    <div class="image-container" v-for="page in pages" :key="page">
      <BaseImage class="reference-thumb" :src="getThumbSource(page)" alt="thumb" @click="$emit('preview-page', page)" />
      <div class="reference-details-container">
        <span class="page-index" @click="$emit('preview-page', page)">
          <span class="page-index-text">p. {{ page }}</span>
          <BbIcon name="arrowright" type="outlined" size="small" class="page-index-icon" />
        </span>
        <div v-if="getPageSecondOrderReferences(page).length" class="page-references">
          <span
            v-for="secondOrderReference in getPageSecondOrderReferences(page)"
            :key="`${secondOrderReference.index}-${page}`"
            class="page-reference-label"
          >
            Ref {{ secondOrderReference.index }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseImage from '~/components/common/BaseImage.vue';

export default {
  name: 'ReferenceCardPages',
  components: { BaseImage },
  emits: ['preview-page'],
  props: {
    pages: {
      type: Array,
      default: () => [],
    },
    pagesThumbs: {
      type: Object,
      default: () => ({}),
    },
    secondOrderReferences: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const getThumbSource = (pageNumber) => props.pagesThumbs?.[pageNumber]?.small || '';

    const getPageSecondOrderReferences = (pageNumber) =>
      props.secondOrderReferences.filter((secondOrderReference) =>
        (secondOrderReference.passages || []).some((passage) => Number(passage.page) === Number(pageNumber)),
      );

    return {
      getThumbSource,
      getPageSecondOrderReferences,
    };
  },
};
</script>

<style lang="scss" scoped>
.referenced-pages {
  display: flex;
  flex-direction: column;
  gap: $bb-spacing-4;
  flex-wrap: wrap;
  margin-top: $bb-spacing-2;
}

.image-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: $bb-spacing-2;

  .image-wrapper {
    width: 124px !important;
  }

  .reference-thumb {
    :deep(img) {
      max-width: 80px;
      max-height: 112px;
      align-self: flex-start;
      cursor: pointer;
      padding: $bb-spacing-2;
      border-radius: $bb-spacing-1;
      background-color: $bb-neutral-5;
    }
  }

  .reference-details-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: $bb-spacing-4;
  }

  .page-index {
    @include bb-medium-text-styles('sm');
    font-weight: 600 !important;
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 2px;
    width: fit-content;
    color: $bb-primary-3;
    cursor: pointer;

    &::after {
      content: '';
      position: absolute;
      left: 4px;
      right: 0;
      bottom: 1px;
      border-bottom: 1px solid currentColor;
    }

    .page-index-text {
      text-decoration: none;
    }

    .page-index-icon {
      transform: rotate(-45deg);
    }
  }

  .page-references {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  }

  .page-reference-label {
    @include bb-medium-text-styles('sm');
    font-weight: 700 !important;
    color: $bb-primary-3;
    background-color: #e3dbff;
    padding: 2px $bb-spacing-3;
    border-radius: 99px;
  }
}
</style>
